import { useQuery } from "@tanstack/react-query";
import { getDocumentId } from "@taskpane/word.api";

export type WorkingDocumentId = string;

export const useWorkingDocumentId = () => {
  const { data, isLoading } = useQuery({
    queryKey: ["workingDocumentId"],
    queryFn: getDocumentId,
    staleTime: Infinity,
  });
  return { documentId: data ?? null, isLoading };
};
